import { CurrencyDollarSimple, CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';
import Text from '../../../components/atoms/Text';

import { PLATAFORMAS } from '../../../shared/constants/platec';
import { Tax } from '../../../@types/Declarations.type';
interface IncomeCardProps {
	platform: string;
	amount: number;
	taxes: Tax[];
}

const IncomeCard = ({ platform, amount, taxes }: IncomeCardProps) => {
	const [isOpen, setIsOpen] = useState(false);

	// Encontrar ISR (tax_type: "01") e IVA (tax_type: "02")
	const isrTax = taxes.find(tax => tax.tax_type === "01");
	const ivaTax = taxes.find(tax => tax.tax_type === "02");

	// Obtener los montos retenidos o usar 0 si no existen
	const isrAmount = isrTax?.retained_amount || 0;
	const ivaAmount = ivaTax?.retained_amount || 0;

	return (
		<div className='self-stretch p-2.5 rounded-lg outline outline-1 outline-offset-[-1px] outline-[#e5e5e5] flex flex-col justify-center items-start gap-2'>
			<div
				className='flex justify-between items-center w-full cursor-pointer'
				onClick={() => setIsOpen(!isOpen)}
			>
				<div className='flex justify-center items-center gap-0.5'>
					<CurrencyDollarSimple
						weight='duotone'
						color='var(--h-primary)'
						size={16}
					/>
					<Text
						size='caption'
						weight='regular'
					>
						{PLATAFORMAS.find((p) => p.rfc === platform)?.nombre || platform}
					</Text>
				</div>
				<div className='flex items-center gap-2'>
					<Text
						size='caption'
						weight='medium'
					>
						${Math.round(amount).toLocaleString('es-MX')}
					</Text>
					<CaretDown
						size={16}
						className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
					/>
				</div>
			</div>

			<div
				className={`self-stretch flex flex-col justify-start items-start gap-2 overflow-hidden transition-all ${isOpen ? 'max-h-40' : 'max-h-0'}`}
			>
				<div className='self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-[#e5e5e5]' />
				<div className='self-stretch flex justify-between items-start gap-2'>
					<div className='flex flex-col justify-start items-start gap-0.5 w-1/2'>
						<Text
							size='body-3'
							weight='light'
						>
							ISR retenido
						</Text>
						<Text
							size='body-3'
							weight='medium'
						>
							${Math.round(isrAmount).toLocaleString('es-MX')}
						</Text>
					</div>
					<div className='flex flex-col justify-start items-start gap-0.5 w-1/2'>
						<Text
							size='body-3'
							weight='light'
						>
							IVA retenido
						</Text>
						<Text
							size='body-3'
							weight='regular'
						>
							${Math.round(ivaAmount).toLocaleString('es-MX')}
						</Text>
					</div>
				</div>
			</div>
		</div>
	);
};

export default IncomeCard;
